<template>
  <div class="feature_wrapper">
    <div class="title_wrapper">
      <img src="../../../assets/images/title/gsts.png" alt="">
      <!-- <p class="title_transition">Why Choose Us</p> -->
      <!-- remove -->
    </div>
    <div class="content_wrapper">
      <div>
        <p class="title">Meet with Great Minds</p>
        <div class="content">
          Learn, share and collaborate with over 200 award-winning scientists, academicians and technology leaders. When the right visionaries are brought together at the right time, breakthroughs and discoveries emerge.  
        </div>
      </div>
      <div>
        <p class="title">Immersion-based Learning Experience</p>
        <div class="content">
          From Greece to Silicon Valley, from “the Eye of Heaven”(China’s FAST telescope) to Jinping Underground Laboratory, GASA students visit inspiring science attractions and world's largest and most complex scientific instruments. We’ve travelled more than 388,470 kilometers, equivalent to circling the equator 9.7 times, in the past eight years.
        </div>
      </div>
      <div>
        <p class="title">Lifelong-learning</p>
        <div class="content">
          Here at GASA we practice lifelong learning with luminaries and peers. Our program is a great option for those who do not wish to pursue a graduate degree or a formal certificate. Over 600 GASAers have shared more than 5,332 hours on the journey of exploring the charm of science.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    created () {},
    methods: {}
  }
</script>
<style lang="less" scoped>
.feature_wrapper {
  width: 80%;
  margin: 0 auto;
  max-width: 1200px;
  .title_wrapper {
    padding: 50px 0 30px;
    width: 100%;
    font-size: 16px;
    color: #666;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      margin-bottom: 20px;
    }
    // remove
    .title_transition {
      font-size: 24px;
      font-weight: 700;
      color: #000;
    }
  }
  .content_wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 30px;
    .title {
      color: #20459d;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 15px 0 10px;
    }
    .content {
      text-align: left;
      line-height: 1.8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/features/features.vue